import { useQuery } from '@tanstack/react-query';
import { useAuth, PaymentService } from '@aaas/shared';

/**
 * Hook to fetch available credit packages
 * Packages rarely change, so we cache for longer
 */
export const usePaymentPackages = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['payment-packages'],
    queryFn: async () => {
      if (!user) {
        throw new Error('User not authenticated');
      }

      const idToken = await user.getIdToken();
      return PaymentService.getCreditPackages(idToken);
    },
    enabled: !!user,
    staleTime: 1000 * 60 * 15, // 15 minutes - packages don't change often
    gcTime: 1000 * 60 * 30, // 30 minutes cache
  });
};
